import React from 'react';

const MultiRingProgress = ({ data }) => {
  const radiusBase = 30;
  const stroke = 8;
  const gap = 10;
  const center = 110;
  const svgSize = 220;

  return (
    <div className="w-full text-center">
      {/* ✅ Centered Donut Chart using mx-auto */}
      <svg
        viewBox={`0 0 ${svgSize} ${svgSize}`}
        width="220"
        height="220"
        preserveAspectRatio="xMidYMid meet"
        className="mx-auto mb-4"
      >
        {data.map((item, index) => {
          const radius = radiusBase + index * (stroke + gap);
          const circumference = 2 * Math.PI * radius;
          const offset = circumference - (item.value / 100) * circumference;

          return (
            <g key={index}>
              <circle
                cx={center}
                cy={center}
                r={radius}
                stroke="#E5E7EB"
                strokeWidth={stroke}
                fill="transparent"
              />
              <circle
                cx={center}
                cy={center}
                r={radius}
                stroke={item.color}
                strokeWidth={stroke}
                fill="transparent"
                strokeDasharray={`${circumference} ${circumference}`}
                strokeDashoffset={offset}
                strokeLinecap="round"
                transform={`rotate(-90 ${center} ${center})`}
              />
            </g>
          );
        })}
        {/* ✅ Center Text */}
        <text
          x={center}
          y={center}
          textAnchor="middle"
          dominantBaseline="middle"
          className="text-base font-semibold fill-gray-700"
        >
          Status
        </text>
      </svg>

      {/* ✅ Horizontal Labels Centered Below */} 
      <div className="inline-flex justify-center gap-6 flex-wrap"> 
      
      {data.map((item, index) => ( <div key={index} className="flex items-center gap-2">
       <span className="w-4 h-4 rounded-full inline-block" style={{ backgroundColor: item.color, width: '15px', height: '16px', borderRadius: '50%', }} >
        
       </span> <span className="text-sm font-medium text-gray-700"> {item.label}: {item.value} </span> </div> ))} </div> </div> ); };

const VehicleStatusChart = ({ stats }) => {
  
  const data = [
    { label: 'Entry', value: stats?.totalEntries || 0, color: '#4475a5' },
    { label: 'Parked', value: stats?.parked || 0, color: '#0ea5e9' },
    { label: 'Exit', value: stats?.exit || 0, color: '#f59e0b' }
  ];

  return <MultiRingProgress data={data} />;
};

export default VehicleStatusChart;
